export const DEFAULT_GROUP_TIME = 60 * 1000;
